<div *ngIf="!isNextVisible">
  <div class="row top-margin-15 nova-font-style create-adjustment-report">
    <div class="col s12 m12 l12 xl12 padding-0">
      <div>
        <div class="row">
          <span [innerHTML]="config.UserInstruction"></span>
        </div>
        <!-- SUMMARY -->
        <div class="row colstyle" *ngIf="(summaryData | json) != '{}'">
          <div class="col s12 m3 l3 xl3 center-align">
            <div class="bold headingtext">Adjustment ID</div>
            <div class="bold headingdata" *ngIf="savedAdjustmentId; else noId">{{summaryData?.adjustmentId}}</div>
            <ng-template #noId><span>-</span></ng-template>
          </div>
          <div class="col s12 m3 l3 xl3 center-align">
            <div class="bold headingtext">Total Records</div>
            <div class="bold headingdata" *ngIf="savedAdjustmentId; else noRecords">{{summaryData?.totalRecords}}</div>
            <ng-template #noRecords>-</ng-template>
          </div>
          <div class="col s12 m3 l3 xl3 center-align">
            <div class="bold headingtext">Total Errored Records</div>
            <div class="bold headingdata" *ngIf="savedAdjustmentId; else noError">{{summaryData?.totalErrorRecords}}
            </div>
            <ng-template #noError>-</ng-template>
          </div>
          <div class="col s12 m3 l3 xl3 center-align">
            <div class="bold headingtext">Total Contributions</div>
            <div class="bold headingdata" *ngIf="savedAdjustmentId; else noCont">
              <span
                [ngClass]=" 0 > summaryData?.totalContributions ? 'neg-amount' : ''">{{summaryData?.formatContribution}}</span>
            </div>
            <ng-template #noCont>-</ng-template>
          </div>
        </div>
        <!-- ERROR MSG -->
        <div class="top-margin-1" *ngIf="isFileError">
          <p id="profile-mobile-view-msg" class="text-red"><span class="k-icon k-i-error"></span><span
              class="bold">Error! The following error was detected in the uploaded adjustment file:</span><br>
            <span class="bold left-margin-25">Column:</span> {{fileErrorMsg.column}}<br>
            <span class="bold left-margin-25">Row:</span> {{fileErrorMsg.row}}<br>
            <span class="bold left-margin-25">Field Value:</span> {{fileErrorMsg.value}}</p>
        </div>
        <div class="top-margin-1 colstyle">
          <!-- FILE UPLAOD -->
          <button class="btn btn-fullwidth background-red right-margin-5 k-button" id="adj-upload-btn"
            *ngIf="operators.Add" (click)="openUploadDialog()">
            <span class='k-icon k-i-upload height-auto'></span>Import File</button>
        </div>
      </div>

      <!-- PANELBAR -->
      <div class="panelbar-wrapper panel-bar-view">
        <kendo-panelbar #panelbar [animate]="true" [keepItemContent]="false" [expandMode]="expandMode"
          (stateChange)="onPanelChange($event)">
          <!-- INVALID -->
          <kendo-panelbar-item class="items first-panel" [id]="0" [title]="''" [expanded]="panelbarData[0].expanded"
            *ngIf="invalidAdjData && invalidAdjData.length > 0">
            <ng-template kendoPanelBarItemTitle>
              <span class="item-heading item-heading-24" [innerHTML]="config.InvalidTitle"></span>
            </ng-template>
            <ng-template kendoPanelBarContent>
              <app-invalid-grid [invalidAdjustmentData]="invalidAdjData" [accessOperators]="operators"
                [adjustmentInputs]="adjustmentInputData" (deleteAction)="deleteSelectedRecords($event)"
                (editAction)="editHandler($event.event, true)" (childDeletedRecord)="displayNotification($event, true)">
              </app-invalid-grid>
            </ng-template>
          </kendo-panelbar-item>
          <!-- ERROR -->
          <kendo-panelbar-item class="items" [id]="1" [title]="''" [expanded]="panelbarData[1].expanded"
            *ngIf="errorAdjData && errorAdjData.length > 0">
            <ng-template kendoPanelBarItemTitle>
              <span class="item-heading item-heading-24" [innerHTML]="config.ErroredTitle"></span>
            </ng-template>
            <ng-template kendoPanelBarContent>
              <app-error-grid [errorAdjustmentData]="errorAdjData" [accessOperators]="operators"
                [adjustmentInputs]="adjustmentInputData" (deleteAction)="deleteSelectedRecords($event)"
                (editAction)="editHandler($event.event, false)"
                (childDeletedRecord)="displayNotification($event, true)"></app-error-grid>
            </ng-template>
          </kendo-panelbar-item>
          <!-- VALID -->
          <kendo-panelbar-item class="items" [id]="2" [title]="''" [expanded]="panelbarData[2].expanded">
            <ng-template kendoPanelBarItemTitle>
              <span class="item-heading item-heading-24" [innerHTML]="config.ValidTitle"></span>
            </ng-template>
            <ng-template kendoPanelBarContent>
              <app-valid-grid [validAdjustmentData]="validAdjData" [accessOperators]="operators"
                [adjustmentInputs]="adjustmentInputData" (deleteAction)="deleteSelectedRecords($event)"
                (addAction)="addHandler($event)" (editAction)="editHandler($event.event, false)"
                (childDeletedRecord)="displayNotification($event, true)">
              </app-valid-grid>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
      </div>

      <!-- ADJUSTMENT GRID -->
      <div class="top-margin-15">
        <!-- ACTION BTNS -->
        <div class="row bottom-margin-0">
          <div class="col s12 m12 l12 xl12 padding-0">
            <div class="margin-15 align-right" id="adj-action-btns">
              <button kendoButton class="btn btn-fullwidth background-red right-margin-10" id="save-Btn"
                [disabled]="(invalidAdjData.length === 0 && validAdjData.length ===0)"
                (click)="onSave4LaterClick()">Save for Later</button>
              <button kendoButton class="btn btn-fullwidth background-red" id="submit-Btn"
                (click)="submitAdjDialog = true"
                [disabled]="validAdjData.length === 0 || errorAdjData.length > 0 || isError">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <app-notification-loading></app-notification-loading>
</div>
<div *ngIf="isNextVisible" class="container">
  <app-adj-record-add-edit-form [isNew]="isNew" [configData]="config" [adjustmentInputs]="adjustmentInputData"
    [model]="adjModelDataItem" [editModel]="editAdjData" (saveResponse)="displayNotification($event, true)"
    (editInvalidAdj)="editInvalidAdjRecords($event)" (closeAddEditForm)="onAddEditClose($event, true)">
  </app-adj-record-add-edit-form>
</div>

<!-- SSN VERIFICATION -->
<kendo-dialog *ngIf="ssnVerifiationDialog" class="app-dialog" [width]="950" (close)="ssnVerifiationDialog = false">
  <kendo-dialog-titlebar>Add New Record</kendo-dialog-titlebar>
  <form novalidate [formGroup]="personalDetailsForm" class="ie-display" id="ssn-validation-form">
    <div id="personal-details">
      <p class="form-label"><span class="bold headingtext">Employee Details</span></p>
      <div class="user-detail">
        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <label for="ssn" class="control-label">SSN<span class="k-required">*</span></label>
            <kendo-maskedtextbox id="ssn" [mask]="ssnMask" formControlName="ssn"
              (valueChange)="onNewSsnChange(personalDetailsForm.controls.ssn.value)"></kendo-maskedtextbox>
            <label for="fiscalYear" class="control-label left-margin-25 right-margin-25">Fiscal Year<span
                class="k-required">*</span></label>
            <kendo-dropdownlist class="width-10em right-margin-10" [data]="allFiscalYears"
              [popupSettings]="{ popupClass: 'nova-font-style text-black' }" formControlName="fiscalYear"
              [filterable]="true" (filterChange)="handleFilter($event)" (valueChange)="FYChange($event)">
            </kendo-dropdownlist>
            <button type="submit" id="search-btn" class="btn background-red left-margin-10"
              (click)="searchEmployeeSsn()" [disabled]="personalDetailsForm.invalid || searchBtnEnable || isProcessing">
              <span *ngIf="!isProcessing" class="k-icon k-i-search"></span>
              <span *ngIf="isProcessing" class="k-icon k-i-loading inner"></span>
            </button>
            <div class="top-margin-1">
              <span class="tooltip-validation"
                *ngIf="personalDetailsForm.controls.ssn.touched && personalDetailsForm.controls.ssn.errors">
                {{config.ValidSSNMsg}}
              </span>
            </div>
          </div>
        </div>
        <div class="text-red" *ngIf="empNotFound">
          <span class="k-icon k-i-warning"></span>{{noContectMsg}}
        </div>

        <div *ngIf="isEmpDetailValid">
          <!-- EMPLOYEMENT INFO -->
          <div class="top-margin-15">
            <p class="headingrow"><span class="bold headingtext">Employment Information</span></p>
          </div>
          <p class="bottom-margin-10" id="grid-msg" [innerHTML]="config.EmployementMsg"></p>
          <div>
            <kendo-grid [kendoGridBinding]="gridData" [sortable]="true" id="terminate-employee-grid"
              [selectable]="{checkboxOnly: true, mode:'single' }" (selectionChange)="onSelectionChange($event)">
              <!-- CHECK BOX -->
              <kendo-grid-checkbox-column media="(min-width: 901px)" [width]="30">
                <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
                  <div class="align-center">
                    <input [kendoGridSelectionCheckbox]="idx" class="k-checkbox" type="checkbox"
                      id="{{'EmpChk'+idx}}" />
                    <label class="k-checkbox-label" for="{{'EmpChk'+idx}}"></label>
                  </div>
                </ng-template>
              </kendo-grid-checkbox-column>
              <!-- FNAME -->
              <kendo-grid-column field="firstName" media="(min-width: 901px)" title="Fisrt Name" [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="align-text">
                    <span>
                      {{dataItem.firstName}}
                    </span>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!-- MI -->
              <kendo-grid-column field="mi" media="(min-width: 901px)" title="MI" [width]="30"
                [headerClass]="{'align-center': true}">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="align-center">
                    <span>
                      {{dataItem.mi}}
                    </span>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!-- LNAME -->
              <kendo-grid-column field="lastName" media="(min-width: 901px)" title="Last Name" [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="align-text">
                    <span>
                      {{dataItem.lastName}}
                    </span>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!-- SYS/PLAN -->
              <kendo-grid-column field="system" media="(min-width: 901px)" title="System/Plan" [width]="200"
                [headerClass]="{'align-id': true}"></kendo-grid-column>
              <!-- LOCATION -->
              <kendo-grid-column field="location" media="(min-width: 901px)" title="Location" [width]="70"
                [headerClass]="{'align-id': true}"></kendo-grid-column>
            </kendo-grid>
          </div>
        </div>
      </div>
    </div>
  </form>
  <kendo-dialog-actions>
    <button kendoButton class="k-button" id="cancel-btn" (click)="onCancelClick(personalDetailsForm)"
      primary="true">Cancel</button>
    <button kendoButton class="k-button k-primary" id="next-btn"
      [disabled]="selectedElements.length === 0 || !personalDetailsForm.valid"
      (click)="isEditInvalidAdj ? onEditNextClick(personalDetailsForm) : onNextClick(personalDetailsForm)">Next</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- UPLOAD ADJUSTMENT FILE -->
<kendo-dialog title="Create Adjustment" class="kendo-upload" [minWidth]="250" *ngIf="createAdjDialog"
  id="create-adjustment-dialog" (close)="closeCreateAdjDialog()">
  <div>
    <kendo-upload #myUpload id="create-adjustment" [autoUpload]="false" [multiple]="false" [saveUrl]="uploadSaveUrl"
      [removeUrl]="uploadRemoveUrl" (complete)="uploadComplete(myUpload)" (upload)="uploadEventHandler($event)"
      (uploadProgress)="uploadProgressEventHandler($event)" [restrictions]="config.AdjustmentFileSupport"
      [disabled]="disableClose" (success)="uploadSuccess($event)" (select)="selectEventHandler($event)"
      (error)="errorEventHandler()">
      <kendo-upload-messages [select]="'Select a file...'">
      </kendo-upload-messages>
    </kendo-upload>
  </div>
</kendo-dialog>

<!-- SAVE FOR LATER ADJUSTMENT -->
<kendo-dialog title="Save Adjustment For Later" class="app-dialog" [width]="615" *ngIf="saveForLaterDialog"
  id="save-for-later-dialog" (close)="saveForLaterDialog = false">
  <p [innerHTML]="saveForLaterMsg"></p>
  <kendo-dialog-actions id="save-adj-btns">
    <button kendoButton class="k-button" id="cancel-btn" [disabled]="loading" (click)="saveForLaterDialog = false"
      primary="true">Cancel</button>
    <button kendoButton class="k-button" id="save-btn" [disabled]="loading" (click)="onSaveAdjustmentClick()"
      primary="true">
      <span *ngIf="!loading">Save</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- SUBMIT ADJUSTMENT -->
<kendo-dialog title="Submit Adjustment" class="app-dialog" *ngIf="submitAdjDialog" [minWidth]="250"
  id="submit-adj-dialog" (close)="submitAdjDialog = false">
  <p>Are you sure you want to submit this Adjustment?</p>
  <kendo-dialog-actions id="submit-adj-btns">
    <button kendoButton class="k-button" id="cancel-btn" [disabled]="loading" (click)="submitAdjDialog = false"
      primary="true">Cancel</button>
    <button kendoButton class="k-button" id="submit-btn" [disabled]="loading" (click)="submitAdjustment()"
      primary="true">
      <span *ngIf="!loading">Submit</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- CONTINUE ADJ UPLOAD -->
<kendo-dialog title="Continue Upload" *ngIf="maxErrorExceeded" id="continue-import-dialog"
  class="kdialog-continue app-dialog">
  <p class="important"> {{config.ContinueAdjMessage}} </p>
  <kendo-dialog-actions id="continueUploadBtn">
    <button kendoButton class="k-button" [disabled]="loading" (click)="continueUpload('no')" primary="true">No</button>
    <button kendoButton class="k-button" [disabled]="loading" (click)="continueUpload('yes')" primary="true">
      <span *ngIf="!loading">Yes</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- DELETE ADJUSTMENT RECORD -->
<kendo-dialog title="Delete Record" *ngIf="deleteMasterAdjDialog" (close)="deleteMasterAdjDialog=false" [minWidth]="250"
  id="delete-adj-dialog" class="app-dialog">
  <p>{{config.DeleteSelectedSSNMsg}}</p>
  <p>{{config.DeleteAdjRecordMsg}}</p>
  <kendo-dialog-actions id="delete-adj-btns">
    <button kendoButton class="k-button" id="no-btn" [disabled]="loading" (click)="deleteMasterAdjDialog=false"
      primary="true">No</button>
    <button kendoButton class="k-button" id="yes-btn" [disabled]="loading" (click)="deleteMasterAdjRecord()"
      primary="true">
      <span *ngIf="!loading">Yes</span>
      <span *ngIf="loading" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
